import { useDeposit } from '@/hooks/uniframe';
import { useRouter, useParams } from 'next/navigation';
import { safeToFormat, times } from '@/utils/number';
import { OrderStatus, Side, TradeType, Token } from '@/apis/market';
// import { useI18n } from '@spot-fe/base-ui';
import { useUserInfo, useI18n } from '@spot-fe/base-ui';
import { checkAccountToRegister } from '@spot-fe/utils';

export enum Stage {
  Coming,
  Trading,
  ToBeDelivered,
  Delivering,
  Completed,
  StopTrade,
  ComingStop,
  ToBeDeliveredStop,
  DeliveringStop,
}

export enum OrderType {
  Buy = 'buy',
  Sell = 'sell',
}
export const tokenStatusType = {
  // 交易期暂停
  StopTradeTypeFirst: 7,
  // 交易未开始暂停·
  ComingStop: 7,
  //等待交割 暂停
  ToBeDeliveredStop: 5,
  // 交割中 暂停
  DeliveringStop: 5,
  // 已休市条件1
  CompletedTypeFirst: 3,
  // 已休市条件2
  CompletedTypeSecond: 6,
}
export enum cancelStatusType {
  // 用户手动取消
  UserCancel = 1,
  // 系统取消
  SystemCancel = 2,
  // 系统取消（成交单）
  SystemCancelTrade = 3,
}

export const useNav = () => {
  const router = useRouter();
  const params = useParams();
  const { isLogin } = useUserInfo();

  const lang = params.lang;

  const navToHome = () => {
    router.push(`/${lang}/trade/spot/pre-market`);
  };

  const navToOrders = (toRegister = false) => {
    if (!isLogin) {
      if (toRegister && checkAccountToRegister('spot_premarket_ongoing')) {
        return;
      }
      navToLogin();
      return;
    }
    router.push(`/${lang}/trade/spot/pre-market/orders`);
  };


  return {
    navToHome,
    navToOrders,
  };
};

export const formatPercentage = (num1?: string, precision = 2) => {
  if (num1 == null) {
    return '--';
  }
  const num = safeToFormat(times(num1, 100));
  return `${num}%`;
};

export interface StageParams {
  deliveryTime: number;
  tradeBeginTime: number;
  tradeEndTime: number;
  tokenStatus: number;
}

export const getStage = (params?: StageParams) => {
  if (!params) {
    return null;
  }
  const { deliveryTime, tradeBeginTime, tradeEndTime } = params || {};
  const now = Date.now();
  if (params?.tokenStatus === tokenStatusType.CompletedTypeFirst || params?.tokenStatus == tokenStatusType.CompletedTypeSecond) {
    return Stage.Completed;
  }
  if (now < tradeBeginTime) {
    if (params?.tokenStatus === tokenStatusType.StopTradeTypeFirst) {
      return Stage.ComingStop
    }
    return Stage.Coming;
  }
  if (now < tradeEndTime || tradeEndTime == 0) {
    if (params?.tokenStatus === tokenStatusType.StopTradeTypeFirst) {
      return Stage.StopTrade
    }
    return Stage.Trading;
  }
  if (now < deliveryTime || deliveryTime == 0 || deliveryTime == null) {
    if (params?.tokenStatus === tokenStatusType.ToBeDeliveredStop) {
      return Stage.ToBeDeliveredStop
    }
    return Stage.ToBeDelivered;
  }
  if (params?.tokenStatus != tokenStatusType.CompletedTypeFirst) {
    if (params?.tokenStatus === tokenStatusType.DeliveringStop) {
      return Stage.DeliveringStop;
    }
    return Stage.Delivering;
  }
  return Stage.Completed;
};

export const navToLogin = async () => {
  const origin = window.location.href;
  const link = `/login?redirect_url=${encodeURIComponent(origin)}`;
  window.location.href = link;
};

export const useCheckUser = () => {
  const { isLogin, isUTA } = useUserInfo();
  const { openUtaUpgradeDialog } = useDeposit();

  const check = () => {
    // debugger
    if (!isLogin) {
      navToLogin();
      return false;
    }
    if (!isUTA) {
      openUtaUpgradeDialog();
      return false;
    }
    return true;
  };

  return { check };
};

export const getSortedList = (tokenList: Token[], lastVisitToken: string) => {
  return tokenList.map((item) => {
    return {
      key: item.tokenName,
      label: item.tokenName,
      isHot: item.hotLabel == 2,
    };
  });
};

export const NewUserGuideReadKey = 'isPreMarketGuideShown';

export const LastVisitKey = 'preMarketLastVisitToken';

export const getLastVisited = () => {
  if (typeof window === 'undefined') return '';
  return window.localStorage.getItem(LastVisitKey);
};

export const marLastVisited = (id: string) => {
  if (typeof window === 'undefined') return '';
  return window.localStorage.setItem(LastVisitKey, id);
};

export const removeLastVisited = () => {
  if (typeof window === 'undefined') return '';
  return window.localStorage.removeItem(LastVisitKey);
};

export const AgreementAgreedKey = 'isPreMarketAgreed';

export const useDictionary = () => {
  const { t } = useI18n();

  const directionNameMap: Record<Side, string> = {
    [Side.Buy]: t('buy1'),
    [Side.Sell]: t('sell1'),
    [Side.All]: t('all'),
  };

  const orderStatusMap: Record<OrderStatus, string> = {
    [OrderStatus.All]: t('all'),
    [OrderStatus.UnSettled]: t('incomplete'),
    [OrderStatus.Settled]: t('tradedAwaitingDelivery'),
    [OrderStatus.Delivered]: t('successfulDelivery'),
    [OrderStatus.Canceled]: t('isCancelled'),
    [OrderStatus.UnDelivered]: t('deliveryFailure'),
    [OrderStatus.Fail]: t('orderFailed'),
    [OrderStatus.PartiallySold]: t('partialTransaction'),
    [OrderStatus.PartiallySold14]: t('partialTransaction'),
    [OrderStatus.PartialDelivery]: t('partDelivery22'),
  };

  const tradeTypeMap: Record<TradeType, string> = {
    [TradeType.Maker]: t('maker'),
    [TradeType.Taker]: t('taker'),
  };

  return {
    directionNameMap,
    orderStatusMap,
    tradeTypeMap,
  };
};
